// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2VrNN","footer":"ReportModalFilter_footer__2doQz"};